import React from 'react'

function AboutFranchisebx() {
  return (
    <></>
  // <div className='w-full max-w-[1250px]     mx-auto xl:px-0 lg:px-0 md:px-5 px-4'>
  //     <div className="mx-auto bg-[#FAFAFA] mt-[80px] mx-auto 2xl:p-[83px] xl:p-[83px] lg:p-[83px] md:p-[20px]">
  //     <h3 className="text-[32px] font-bold ">
  //       About FranchiseBX
  //     </h3>
  //     <p className="mt-[20px] text-paragraph_color text-balance">
  //       Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod
  //       tempor incididunt ut labore et dolore magna aliqua. Vitae elementum
  //       curabitur vitae nunc sed velit. Adipiscing at in tellus integer feugiat
  //       scelerisque varius. In aliquam sem fringilla ut morbi tincidunt. Tortor
  //       at auctor urna nunc id cursus metus aliquam. Arcu non sodales neque
  //       sodales ut etiam sit. Sodales neque sodales ut etiam sit amet nisl
  //       purus. Aliquam sem et tortor consequat id. Euismod elementum nisi quis
  //       eleifend quam adipiscing vitae proin sagittis. Odio aenean sed
  //       adipiscing diam. Cum sociis natoque penatibus et magnis dis parturient
  //       montes nascetur. Parturient montes nascetur ridiculus mus mauris vitae.
  //       Et magnis dis parturient montes nascetur. Morbi tincidunt augue interdum
  //       velit. Enim blandit volutpat maecenas volutpat. Odio facilisis mauris
  //       sit amet massa. Ut faucibus pulvinar elementum integer enim neque
  //       volutpat ac. Ac auctor augue mauris augue neque gravida in fermentum et.
  //     </p>
  //   </div>
  // </div>
  );
}

export default AboutFranchisebx
